import { rest } from '@ax2/common/index';
import SignInTO from '../model/SignInTO';
import SignUpTO from '../model/SignUpTO';
import { clientNoInterceptors } from './client';
import { AuthResponseTO } from '../model/AuthResponseTO';

export type RestError = rest.RestError;

export function signIn(data: SignInTO): Promise<AuthResponseTO> {
  return rest.api<AuthResponseTO>('/client/signin', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf8',
    },
    data: JSON.stringify(data),
  });
}

export function signUp(data: SignUpTO): Promise<AuthResponseTO> {
  return rest.api<AuthResponseTO>('/client/signup', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(data),
  });
}

export function signOut(): Promise<void> {
  return rest.api<void>('/client/signout', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
}

export function getProfile(redirect: boolean = false): Promise<AuthResponseTO> {
  return rest.api<AuthResponseTO>(
    '/client/profile',
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    },
    redirect ? undefined : clientNoInterceptors
  );
}
